import type { Traducao } from '../tipos';

/** Textos de `templates`. Preenchido pela tradução da área — ver ../README.md. */
export const templates: Traducao = {
  pt: {
    lista: {
      titulo: 'Templates',
      subtitulo: 'Gerencie templates para acelerar a criação de apreciações',
      modelosPartes: 'Modelos e Partes',
      novoTemplate: 'Novo Template',
      filtroBuscaPlaceholder: 'Buscar por nome, tipo...',
      filtroCategoria: 'Categoria',
      origemSimples: 'Template Simples',
      origemMultiparte: 'Template de Máquina',
      origemParte: 'Template de Parte',
      carregando: 'Carregando templates...',
      vazioTitulo: 'Nenhum template encontrado',
      vazioComFiltro: 'Tente ajustar os filtros de busca',
      vazioSemFiltro: 'Crie seu primeiro template para começar',
      criarTemplate: 'Criar Template',
      tipoNaoEspecificado: 'Não especificado',
      tipoParteAvulsa: 'Parte avulsa',
      badgeMaquina: 'Máquina',
      badgeParte: 'Parte',
      badgeSimples: 'Simples',
      semDescricao: 'Sem descrição',
      contagemPartesRiscos: '{{partes}} parte(s) · {{riscos}} risco(s)',
      contagemRiscos: '{{riscos}} risco(s)',
      contagemUsos: 'Usado {{total}} vezes',
      grupo: 'Grupo: {{nome}}',
      norma: 'Norma: {{norma}}',
      acaoDesativar: 'Desativar template',
      acaoRemover: 'Remover template',
      duplicarPrompt: 'Digite o nome para o template duplicado:',
      duplicarSugestao: '{{nome}} (Cópia)',
      duplicarSucesso: 'Template duplicado com sucesso!',
      duplicarErroDetalhe: 'Erro ao duplicar template: {{mensagem}}',
      duplicarErro: 'Erro ao duplicar template',
      removerConfirmarDesativar: 'Tem certeza que deseja desativar o template "{{nome}}"?',
      removerConfirmarRemover: 'Tem certeza que deseja remover o template "{{nome}}"?',
      removerSucesso: 'Template removido/desativado com sucesso!',
      removerErroDetalhe: 'Erro ao remover template: {{mensagem}}',
      removerErro: 'Erro ao remover template',
      guiaTitulo: 'Como Criar um Template',
      guiaPasso1Titulo: '1. Defina o Template',
      guiaPasso1Texto: 'Crie um template baseado em uma apreciação existente ou do zero',
      guiaPasso2Titulo: '2. Personalize',
      guiaPasso2Texto: 'Adicione campos personalizados e configurações específicas',
      guiaPasso3Titulo: '3. Use Novamente',
      guiaPasso3Texto: 'Aplique o template para criar novas apreciações rapidamente',
    },
    form: {
      secaoInformacoes: 'Informações do Template',
      nome: 'Nome do Template *',
      norma: 'Norma Referência *',
      descricao: 'Descrição (Opcional)',
      tipoReferencia: 'Tipo da Máquina/Template (String de Referência)',
      tipoReferenciaAjuda: 'O tipo é definido na criação através do grupo e tipo de máquina',
      tipoMaquina: 'Tipo de Máquina',
      tipoMaquinaPlaceholder: 'Ex: Prensa Excêntrica',
      grupo: 'Grupo',
      grupoNenhum: 'Sem grupo',
      salvarAlteracoes: 'Salvar Alterações',
      erroNomeObrigatorio: 'Informe o nome do template',
    },
    partes: {
      titulo: 'Lista de Criação de Partes',
      adicionar: 'Adicionar Parte',
    },
    estado: {
      erroDesconhecido: 'Erro desconhecido',
      carregandoTemplate: 'Carregando template...',
      erroCarregar: 'Erro ao carregar o template: {{mensagem}}',
      erroCarregarInesperado: 'Erro inesperado tentando carregar o template',
      erroAtualizar: 'Erro ao atualizar template',
      erroAtualizarDetalhe: 'Erro ao atualizar template:\n\n{{mensagem}}',
      erroSalvar: 'Erro ao salvar template. Tente novamente.',
    },
    criar: {
      titulo: 'Novo Template',
      subtitulo: 'Desenvolva um padrão através de uma estrutura de Grupos, Tipos e Criação de Partes',
      nomePlaceholder: 'Ex: Padrão Torno CNC Master',
      descricaoPlaceholder: 'Detalhes ou finalidade deste template',
      partesSubtitulo: 'Crie as partes da máquina e vincule perigos a elas.',
      salvarTemplate: 'Salvar Template',
      erroSemProjeto: 'Selecione um projeto primeiro',
      erroCamposObrigatorios: 'Preencha os campos obrigatórios (Nome, Norma, Grupo e Tipo)',
      sucesso: 'Template criado com sucesso!',
      erroCriar: 'Erro ao criar template',
      erroCriarDetalhe: 'Erro ao criar template:\n\n{{mensagem}}',
    },
    editar: {
      titulo: 'Editar Template',
      subtitulo: 'Atualize as informações pré-configuradas e riscos do template',
      partesSubtitulo: 'Gerencie as partes e perigos deste template.',
      erroCamposObrigatorios: 'Preencha os campos obrigatórios do template (Nome, Tipo e Norma)',
      sucesso: 'Template atualizado com sucesso!',
    },
    multiparte: {
      titulo: 'Editar Template de Máquina',
      resumo: '{{partes}} parte(s) · {{riscos}} risco(s)',
      partesTitulo: 'Partes do Template',
      partesSubtitulo: 'Edite as partes e riscos que serão aplicados nas apreciações.',
      vaziasTitulo: 'Partes sem riscos definidos',
      vaziasAjuda: 'Ao aplicar o template, cada uma destas partes gera um risco inicial em branco.',
      sucesso: 'Template de máquina atualizado com sucesso!',
    },
    parte: {
      titulo: 'Editar Template de Parte',
      resumo: '{{riscos}} risco(s) neste template',
      riscosTitulo: 'Riscos da Parte',
      riscosSubtitulo: 'Clique na parte para editar seus riscos. Ao aplicar o template, estes riscos são copiados para a apreciação.',
      carregando: 'Carregando template de parte...',
      erroCarregar: 'Erro ao carregar o template de parte: {{mensagem}}',
      erroCarregarInesperado: 'Erro inesperado tentando carregar o template de parte',
      erroSemRiscos: 'O template de parte precisa de pelo menos um risco',
      sucesso: 'Template de parte atualizado com sucesso!',
      erroAtualizar: 'Erro ao atualizar template de parte',
      erroAtualizarDetalhe: 'Erro ao atualizar template de parte:\n\n{{mensagem}}',
      erroSalvar: 'Erro ao salvar template de parte. Tente novamente.',
    },
    modelos: {
      semProjeto: 'Selecione um projeto para gerenciar os modelos (grupos e tipos).',
      voltar: 'Voltar para Templates',
      titulo: 'Modelos de Máquinas',
      subtitulo: 'Crie a estrutura padrão de partes e riscos para cada Grupo e Tipo de máquina',
      ajuda: '<strong>Como usar:</strong> Primeiro selecione (ou crie) a categoria principal do equipamento em <strong>Grupo</strong>. Depois, defina a variação específica em <strong>Tipo</strong>. Por fim, cadastre as partes e riscos padronizados para esse modelo.',
      salvoSucesso: 'Modelo de máquina salvo com sucesso!',
      vazio: 'Selecione um <strong>Tipo de Máquina</strong> acima para gerenciar sua lista de partes.',
    },
    editorPartes: {
      salvarTudo: 'Salvar Partes e Riscos',
      vazio: 'Nenhuma parte cadastrada para este modelo.',
      parteNumero: 'Parte {{numero}}:',
      parteNomePlaceholder: 'Nome da parte (ex: Fuso principal)',
      removerParte: 'Remover Parte',
      novaPartePlaceholder: 'Nome da nova parte...',
      adicionarNovaParte: 'Adicionar Nova Parte',
      confirmarRemoverParte: 'Tem certeza que deseja remover esta parte e todos os seus riscos?',
      erroSalvarPartes: 'Erro ao salvar as partes.',
      erroConexaoSalvar: 'Erro de conexão ao salvar partes.',
      promptTipoPerigo: 'Novo Tipo de Perigo:',
      promptCategoria: 'Nova Categoria:',
      promptHrn: 'Novo valor HRN:',
    },
    grupo: {
      titulo: 'Gerenciar Grupos de Templates',
      novo: 'Novo Grupo',
      criarTitulo: 'Criar Novo Grupo',
      nome: 'Nome do Grupo',
      nomePlaceholder: 'Ex: Correias Transportadoras',
      descricaoOpcional: 'Descrição (opcional)',
      descricaoPlaceholder: 'Descreva o grupo...',
      carregando: 'Carregando grupos...',
      vazio: 'Nenhum grupo criado. Clique em "Novo Grupo" para começar.',
      contagemTemplates: '{{total}} template(s)',
      criadoEm: 'Criado em {{data}}',
      erroNomeObrigatorio: 'Nome do grupo é obrigatório',
      erroCarregar: 'Erro ao carregar grupos',
      erroCriar: 'Erro ao criar grupo',
      erroAtualizar: 'Erro ao atualizar grupo',
      erroRemover: 'Erro ao remover grupo',
      confirmarRemover: 'Tem certeza que deseja remover este grupo?',
    },
    seletor: {
      titulo: 'Classificação Padrão',
      grupoLabel: 'Grupo de Máquina (Categoria)',
      grupoPlaceholder: 'Ex: Torno, Prensa...',
      grupoIndisponivel: 'Nenhum grupo disponível',
      grupoSelecione: 'Selecione um grupo...',
      grupoNovo: 'Novo Grupo',
      grupoSemCadastro: 'Nenhum grupo cadastrado para este projeto.',
      grupoCriarPrimeiro: 'Criar primeiro grupo',
      grupoAjuda: 'Crie o grupo primeiro para classificar a categoria ampla do equipamento (ex.: Tornos).',
      tipoLabel: 'Tipo (Modelo Específico)',
      tipoPlaceholder: 'Ex: Torno CNC Vertical...',
      tipoSelecione: 'Selecione um tipo...',
      tipoCrieGrupo: 'Crie um grupo para habilitar os tipos',
      tipoSelecioneGrupo: 'Selecione um grupo primeiro',
      tipoNovo: 'Novo Tipo',
      tipoAjuda: 'A variação específica dentro do grupo selecionado.',
      erroCarregarGrupos: 'Erro ao carregar os grupos.',
      erroConexaoGrupos: 'Erro de conexão ao carregar grupos.',
      erroCarregarTipos: 'Erro ao carregar os tipos.',
      erroConexaoTipos: 'Erro de conexão ao carregar tipos.',
      erroCriarGrupo: 'Erro ao criar grupo',
      erroCriarTipo: 'Erro ao criar tipo',
    },
  },
  en: {
    lista: {
      titulo: 'Templates',
      subtitulo: 'Manage templates to speed up creating risk assessments',
      modelosPartes: 'Models and Parts',
      novoTemplate: 'New Template',
      filtroBuscaPlaceholder: 'Search by name, type...',
      filtroCategoria: 'Category',
      origemSimples: 'Simple Template',
      origemMultiparte: 'Machine Template',
      origemParte: 'Part Template',
      carregando: 'Loading templates...',
      vazioTitulo: 'No templates found',
      vazioComFiltro: 'Try adjusting the search filters',
      vazioSemFiltro: 'Create your first template to get started',
      criarTemplate: 'Create Template',
      tipoNaoEspecificado: 'Not specified',
      tipoParteAvulsa: 'Standalone part',
      badgeMaquina: 'Machine',
      badgeParte: 'Part',
      badgeSimples: 'Simple',
      semDescricao: 'No description',
      contagemPartesRiscos: '{{partes}} part(s) · {{riscos}} risk(s)',
      contagemRiscos: '{{riscos}} risk(s)',
      contagemUsos: 'Used {{total}} times',
      grupo: 'Group: {{nome}}',
      norma: 'Standard: {{norma}}',
      acaoDesativar: 'Deactivate template',
      acaoRemover: 'Remove template',
      duplicarPrompt: 'Enter the name for the duplicated template:',
      duplicarSugestao: '{{nome}} (Copy)',
      duplicarSucesso: 'Template duplicated successfully!',
      duplicarErroDetalhe: 'Error duplicating template: {{mensagem}}',
      duplicarErro: 'Error duplicating template',
      removerConfirmarDesativar: 'Are you sure you want to deactivate the template "{{nome}}"?',
      removerConfirmarRemover: 'Are you sure you want to remove the template "{{nome}}"?',
      removerSucesso: 'Template removed/deactivated successfully!',
      removerErroDetalhe: 'Error removing template: {{mensagem}}',
      removerErro: 'Error removing template',
      guiaTitulo: 'How to Create a Template',
      guiaPasso1Titulo: '1. Define the Template',
      guiaPasso1Texto: 'Create a template based on an existing risk assessment or from scratch',
      guiaPasso2Titulo: '2. Customize',
      guiaPasso2Texto: 'Add custom fields and specific settings',
      guiaPasso3Titulo: '3. Reuse It',
      guiaPasso3Texto: 'Apply the template to create new risk assessments quickly',
    },
    form: {
      secaoInformacoes: 'Template Information',
      nome: 'Template Name *',
      norma: 'Reference Standard *',
      descricao: 'Description (Optional)',
      tipoReferencia: 'Machine/Template Type (Reference String)',
      tipoReferenciaAjuda: 'The type is set at creation through the machine group and type',
      tipoMaquina: 'Machine Type',
      tipoMaquinaPlaceholder: 'e.g. Eccentric Press',
      grupo: 'Group',
      grupoNenhum: 'No group',
      salvarAlteracoes: 'Save Changes',
      erroNomeObrigatorio: 'Enter the template name',
    },
    partes: {
      titulo: 'Part Creation List',
      adicionar: 'Add Part',
    },
    estado: {
      erroDesconhecido: 'Unknown error',
      carregandoTemplate: 'Loading template...',
      erroCarregar: 'Error loading the template: {{mensagem}}',
      erroCarregarInesperado: 'Unexpected error while loading the template',
      erroAtualizar: 'Error updating template',
      erroAtualizarDetalhe: 'Error updating template:\n\n{{mensagem}}',
      erroSalvar: 'Error saving template. Please try again.',
    },
    criar: {
      titulo: 'New Template',
      subtitulo: 'Build a standard through a structure of Groups, Types and Part Creation',
      nomePlaceholder: 'e.g. CNC Master Lathe Standard',
      descricaoPlaceholder: 'Details or purpose of this template',
      partesSubtitulo: 'Create the machine parts and link hazards to them.',
      salvarTemplate: 'Save Template',
      erroSemProjeto: 'Select a project first',
      erroCamposObrigatorios: 'Fill in the required fields (Name, Standard, Group and Type)',
      sucesso: 'Template created successfully!',
      erroCriar: 'Error creating template',
      erroCriarDetalhe: 'Error creating template:\n\n{{mensagem}}',
    },
    editar: {
      titulo: 'Edit Template',
      subtitulo: 'Update the preset information and risks of the template',
      partesSubtitulo: 'Manage the parts and hazards of this template.',
      erroCamposObrigatorios: 'Fill in the required template fields (Name, Type and Standard)',
      sucesso: 'Template updated successfully!',
    },
    multiparte: {
      titulo: 'Edit Machine Template',
      resumo: '{{partes}} part(s) · {{riscos}} risk(s)',
      partesTitulo: 'Template Parts',
      partesSubtitulo: 'Edit the parts and risks that will be applied to risk assessments.',
      vaziasTitulo: 'Parts with no risks defined',
      vaziasAjuda: 'When the template is applied, each of these parts generates a blank initial risk.',
      sucesso: 'Machine template updated successfully!',
    },
    parte: {
      titulo: 'Edit Part Template',
      resumo: '{{riscos}} risk(s) in this template',
      riscosTitulo: 'Part Risks',
      riscosSubtitulo: 'Click the part to edit its risks. When the template is applied, these risks are copied into the risk assessment.',
      carregando: 'Loading part template...',
      erroCarregar: 'Error loading the part template: {{mensagem}}',
      erroCarregarInesperado: 'Unexpected error while loading the part template',
      erroSemRiscos: 'The part template needs at least one risk',
      sucesso: 'Part template updated successfully!',
      erroAtualizar: 'Error updating part template',
      erroAtualizarDetalhe: 'Error updating part template:\n\n{{mensagem}}',
      erroSalvar: 'Error saving part template. Please try again.',
    },
    modelos: {
      semProjeto: 'Select a project to manage the models (groups and types).',
      voltar: 'Back to Templates',
      titulo: 'Machine Models',
      subtitulo: 'Create the standard structure of parts and risks for each machine Group and Type',
      ajuda: '<strong>How to use:</strong> First select (or create) the main equipment category under <strong>Group</strong>. Then define the specific variation under <strong>Type</strong>. Finally, register the standard parts and risks for that model.',
      salvoSucesso: 'Machine model saved successfully!',
      vazio: 'Select a <strong>Machine Type</strong> above to manage its list of parts.',
    },
    editorPartes: {
      salvarTudo: 'Save Parts and Risks',
      vazio: 'No parts registered for this model.',
      parteNumero: 'Part {{numero}}:',
      parteNomePlaceholder: 'Part name (e.g. Main spindle)',
      removerParte: 'Remove Part',
      novaPartePlaceholder: 'New part name...',
      adicionarNovaParte: 'Add New Part',
      confirmarRemoverParte: 'Are you sure you want to remove this part and all of its risks?',
      erroSalvarPartes: 'Error saving the parts.',
      erroConexaoSalvar: 'Connection error while saving parts.',
      promptTipoPerigo: 'New Hazard Type:',
      promptCategoria: 'New Category:',
      promptHrn: 'New HRN value:',
    },
    grupo: {
      titulo: 'Manage Template Groups',
      novo: 'New Group',
      criarTitulo: 'Create New Group',
      nome: 'Group Name',
      nomePlaceholder: 'e.g. Conveyor Belts',
      descricaoOpcional: 'Description (optional)',
      descricaoPlaceholder: 'Describe the group...',
      carregando: 'Loading groups...',
      vazio: 'No groups created. Click "New Group" to get started.',
      contagemTemplates: '{{total}} template(s)',
      criadoEm: 'Created on {{data}}',
      erroNomeObrigatorio: 'Group name is required',
      erroCarregar: 'Error loading groups',
      erroCriar: 'Error creating group',
      erroAtualizar: 'Error updating group',
      erroRemover: 'Error removing group',
      confirmarRemover: 'Are you sure you want to remove this group?',
    },
    seletor: {
      titulo: 'Standard Classification',
      grupoLabel: 'Machine Group (Category)',
      grupoPlaceholder: 'e.g. Lathe, Press...',
      grupoIndisponivel: 'No group available',
      grupoSelecione: 'Select a group...',
      grupoNovo: 'New Group',
      grupoSemCadastro: 'No groups registered for this project.',
      grupoCriarPrimeiro: 'Create first group',
      grupoAjuda: 'Create the group first to classify the broad equipment category (e.g. Lathes).',
      tipoLabel: 'Type (Specific Model)',
      tipoPlaceholder: 'e.g. Vertical CNC Lathe...',
      tipoSelecione: 'Select a type...',
      tipoCrieGrupo: 'Create a group to enable types',
      tipoSelecioneGrupo: 'Select a group first',
      tipoNovo: 'New Type',
      tipoAjuda: 'The specific variation within the selected group.',
      erroCarregarGrupos: 'Error loading groups.',
      erroConexaoGrupos: 'Connection error while loading groups.',
      erroCarregarTipos: 'Error loading types.',
      erroConexaoTipos: 'Connection error while loading types.',
      erroCriarGrupo: 'Error creating group',
      erroCriarTipo: 'Error creating type',
    },
  },
};
